import { differenceInCalendarDays, parseISO } from "date-fns";
import { CheckedStatusEnum } from "./types";
import { DATE_RANGE_AFTER_YEARS, DATE_RANGE_BEFORE_YEARS } from "./consts";
export const isFinalStatus = (status) => status === CheckedStatusEnum.NOT_APPLICABLE ||
    status === CheckedStatusEnum.COMPLETED;
/**
 * Adds the status to "bare" checklist item.
 * Necessary for items checked before the feature flag for CHECKLIST_ITEM_STATUS is turned off.
 */
export const coalesceCheckedStatus = (fieldValue) => fieldValue.checkedStatus ??
    (fieldValue.checked ? CheckedStatusEnum.COMPLETED : CheckedStatusEnum.OPEN);
export const getDateRange = (years) => {
    const today = new Date();
    const nextYear = today.getFullYear() + years;
    const expectedDay = new Date(nextYear, 11, 31);
    return differenceInCalendarDays(expectedDay, today);
};
export const deserializeDateValue = (value) => value ? parseISO(value) : new Date();
export const getDateRangeBefore = () => getDateRange(DATE_RANGE_BEFORE_YEARS);
export const getDateRangeAfter = () => getDateRange(DATE_RANGE_AFTER_YEARS);
